const groups = [
  {
    title: "Backend & Architecture",
    skills: [".NET Core", "C#", "ASP.NET MVC", "SQL Server", "ASP.NET Web API", "Microservices Architecture", "Entity Framework", "Dapper", "Redis", "RabbitMQ", "Relational Database Design", "System Design", "Domain-Driven Design", "Angular", "JavaScript", "TypeScript", "RxJS / State Management", "HTML5"],
  },
  {
    title: "Leadership & Process",
    skills: ["Technical Team Leadership", "Product Ownership", "Business Analysis", "Agile Methodologies", "Scrum Mastery", "Cross-Functional Collaboration", "Stakeholder Communication", "Project Management", "Team Building & Mentorship", "Technical Strategy & Roadmapping", "Process Optimization"],
  },
  {
    title: "Cloud & Infra",
    skills: ["Amazon Web Services (AWS)", "Microsoft Azure", "VPS Hosting", "Docker", "CI/CD Pipelines", "Terraform", "CloudFormation"],
  },
  {
    title: "Emerging Tech",
    skills: ["AI Integration", "Prompt Engineering", "Web Scraping & Data Extraction", "Intelligent Workflow Automation", "AI-Assisted SDLC", "AI-Driven Decision Support"],
  },
];

export function Skills() {
  return (
    <section id="skills" className="border-y border-border bg-surface/30 py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-6">
        <div className="mb-14 max-w-2xl">
          <p className="font-mono text-sm text-primary">// Technical Arsenal</p>
          <h2 className="mt-3 text-3xl font-bold tracking-tight text-foreground md:text-4xl">
            The stack that powers production.
          </h2>
          <p className="mt-4 text-muted-foreground">
            A pragmatic toolkit refined over a decade of building, scaling, and shipping.
          </p>
        </div>

        <div className="grid gap-6 md:grid-cols-2">
          {groups.map((g) => (
            <div
              key={g.title}
              className="rounded-xl border border-border bg-surface p-6 transition-smooth hover:border-primary/40"
            >
              <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary">
                {g.title}
              </h3>
              <div className="flex flex-wrap gap-2">
                {g.skills.map((s) => (
                  <span
                    key={s}
                    className="rounded-full border border-border bg-background/60 px-3 py-1.5 text-sm font-medium text-foreground transition-smooth hover:border-primary hover:bg-primary/10 hover:text-primary"
                  >
                    {s}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
